var site = site || {};
var generic = generic || {};
var Mustache = Mustache || {};

(function ($) {
  Drupal.behaviors.basic_product_sku_v1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }

      this.attached = true;
      var $thismodule = $('.js-basic-product-sku', context);
      var $productContainers = $thismodule.find('.js-basic-product-sku__container.product');
      var $skuContainers = $thismodule.find('.js-basic-product-sku__container.sku');
      var productsData;
      var skuData;

      if (page_data['custom-mpp']) {
        productsData = page_data['custom-mpp']['products'];
      }
      if (page_data['product-input-type']) {
        skuData = page_data['product-input-type']['skus'];
      }

      /* loop through all products and bind the data to the mustache and render */
      function renderProducts(html) {
        $productContainers.each(function () {
          var $productContainer = $(this);
          var productId = $productContainer.data('product-id');
          var currentProductData = _.find(productsData, function (p) {
            return p.PRODUCT_ID === productId;
          });

          currentProductData['first_medium_image'] = currentProductData['skus'][0]['MEDIUM_IMAGE'][0];
          currentProductData['valuePriceRange'] = currentProductData['priceRange'];
          currentProductData['shop_now'] = site.translations.product.shop_now;

          var rendered = Mustache.render(html, currentProductData);

          $productContainer.html(rendered);
        });
      }

      /* loop through all skus and bind the data to the mustache and render */
      function renderSkus(html) {
        $skuContainers.each(function () {
          var $skuContainer = $(this);
          var productId = $skuContainer.data('product-id');
          var currentSkuData = _.find(skuData, function (p) {
            return p.PRODUCT_ID === productId;
          });

          currentSkuData['first_medium_image'] = currentSkuData['SMALL_IMAGE'];
          currentSkuData['url'] = currentSkuData['product']['url'] + '#/shade/' + currentSkuData['SHADENAME'].replace(' ', '-');
          currentSkuData['PROD_RGN_NAME'] = currentSkuData['product']['PROD_RGN_NAME'];
          currentSkuData['PROD_RGN_SUBHEADING'] = currentSkuData['product']['PROD_RGN_SUBHEADING'];
          currentSkuData['valuePriceRange'] = currentSkuData['formattedPrice'];
          currentSkuData['shop_now'] = site.translations.product.shop_now;

          var rendered = Mustache.render(html, currentSkuData);

          $skuContainer.html(rendered);
        });
      }

      /* take down the basic brief html */
      generic.template.get({
        path: '/sites/esteelauder/themes/estee_base/template_api/_partials/basic_product_sku_brief_v1/basic_product_sku_brief_v1.mustache',
        forceReload: true,
        callback: function (html) {
          renderProducts(html);
          renderSkus(html);
        }
      });
    }
  };
})(jQuery);
